import React, { useContext, useState } from 'react';
import { Button, Paper } from '@material-ui/core';
import Blink from 'react-blink-text';
import Modal from '@material-ui/core/Modal';
import useStyles from '../styles';
import { SocketContext } from '../Context';

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const Notifications = () => {
  const { answerCall, callAccepted, call } = useContext(SocketContext);
  const callerName = `${call.name} is calling`;
  const [modalStyle] = useState(getModalStyle);
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (open) {
      setOpen(false);
      window.location.reload();
    }
  };

  return (
    <>
      {call.isReceivingCall && !callAccepted && (
      <div>
        <Modal
          open={open}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Paper style={modalStyle} className={classes.paperModal}>
            <Blink
              color="black"
              fontSize="30px"
              text={callerName}
            >
              <h6>{call.name} is calling:</h6>
            </Blink>
            <Button variant="contained" color="primary" onClick={answerCall}>
              Answer {handleOpen}
            </Button>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              Decline
            </Button>
          </Paper>
        </Modal>
      </div>
      )}
    </>
  );
};

export default Notifications;
